import ISiteDiaryItemOrderViewModel from "interfaces/SiteDiary/ItemOrder/ISiteDiaryItemOrderViewModel";

const ItemTemplate = (props: ISiteDiaryItemOrderViewModel): any => {
  const { orderType, item } = props;
  return (
    <span data-testid="item">
      <span>
        {orderType}
&nbsp;-&nbsp;
        {item}
      </span>
    </span>
  );
};
export default ItemTemplate;
